import { render, staticRenderFns } from "./SidebarUI.vue?vue&type=template&id=2fe6934a&"
import script from "./SidebarUI.vue?vue&type=script&lang=js&"
export * from "./SidebarUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports